import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {
  size,
  email,
  regex,
  required,
  numeric,
  length,
  max,
  integer,
  min_value,
} from "vee-validate/dist/rules";
import i18n from "./i18n";
import { validateVatNumber } from "../utils/util";

const VeeValidate = {
  install(Vue) {
    extend("required", {
      message: () => i18n.t("mp:form.validation.message.required"),
      ...required,
    });

    extend("statementRequired", {
      message: () => i18n.t("mp:form.validation.message.required"),
      validate: (value) => {
        return !(
          value === undefined ||
          value === null ||
          value === "" ||
          value === false
        );
      },
    });

    extend("size", {
      ...size,
      message: () => i18n.t("mp:form.validation.message.size"),
    });

    extend("email", {
      ...email,
      message: () => i18n.t("mp:form.validation.message.email"),
    });

    extend("regex", {
      ...regex,
      message: () => i18n.t("mp:form.validation.message.regex"),
    });

    extend("past", {
      message: () => i18n.t("mp:form.validation.message.past"),
      validate: (value) => {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        value.setHours(0, 0, 0, 0);
        return today >= value;
      },
    });

    extend("future", {
      message: () => i18n.t("mp:form.validation.message.future"),
      validate: (value) => {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        value.setHours(0, 0, 0, 0);
        return today <= value;
      },
    });

    extend("phone", {
      message: () => i18n.t("mp:form.validation.message.phone"),
      validate: (value) => {
        const regex = new RegExp(
          "[+36 ][0-9][0-9][ ][0-9][0-9][0-9][ ][0-9][0-9][0-9][0-9]"
        );

        return regex.test(value);
      },
    });

    extend("vatNumber", {
      message: () => i18n.t("mp:form.validation.message.vat_number"),
      validate: (value) => {
        return validateVatNumber(value);
        // return true;
      },
    });

    extend("numeric", {
      ...numeric,
      message: () => i18n.t("mp:form.validation.message.numeric"),
    });

    extend("length", {
      ...length,
      message: (field, { length }) =>
        i18n.t("mp:form.validation.message.length", { length }),
    });

    extend("max", {
      ...max,
      message: (field, { length }) => {
        return i18n.t("mp:form.validation.message.max", { max: length });
      },
    });

    extend("integer", {
      ...integer,
      message: () => i18n.t("mp:form.validation.message.integer"),
    });

    extend("min_value", {
      ...min_value,
      message: () => i18n.t("mp:form.validation.message.min_value"),
    });

    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
  },
};

export default VeeValidate;
